const productSchema = ({
  name,
  description,
  image,
  url,
  sku,
  category = "Bentonite Minerals",
}) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "@id": `${url}#product`,
  name,
  description,
  image: image ? [image] : undefined,
  sku: sku || undefined,
  category,

  brand: {
    "@type": "Brand",
    name: "Iris Impulse",
  },

  manufacturer: {
    "@id": "https://irisimpulse.com/#organization",
  },

  mainEntityOfPage: {
    "@id": `${url}#webpage`,
  },
});

export default productSchema;
